var quantityLabel = "Quantité";
var quantityFlyoutHeader = "Choisissez la quantité";
var quantityFlyoutCTA = "Sélectionner cette quantité";
var closeButton = "Fermer";
var pricePlaceholder = "...";
var priceLabel = "Prix";
var unitPriceLabel = "Prix ​​unitaire";
var incompatibilityMessage = "Non disponible avec les autres sélections : ";
var select = "Sélectionnez...";
var percentSavings = "{{{PERCENT}}}% d’économie";
var sale = "solde";
var amountSavings = "{{{AMOUNT}}}% d’économie/unité";
var amountSavingsWithSale = "{{{AMOUNT}}}% d’économie/unité + solde";
var seeMoreQuantities = "Afficher plus de quantités";
var required = "Obligatoire";
var sample = "Échantillon";
var estimatedQuantity = "Quantité estimée";
var numberOfRecipients = "{{{COUNT}}} destinataires";
var recommendedCallout = "Recommandé";
var newCallout = "Nouveau";
var incompatibleLabel = "Incompatible";
var outOfStockCallout = "En rupture de stock";
var dismissAlert = "Ignorer l’alerte";
var unwindingMessage_1 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Incompatible avec plus de {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1 = "Pour être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} a été désélectionné.";
var unwindingAlertMessage_2 = "Pour être compatibles avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}} ont été désélectionnés.";
var unwindingAlertMessage_3 = "Pour être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}} ont été désélectionnés.";
var unwindingAlertMessage_more = "Pour être compatibles avec {{{ATTRIBUTE}}} {{{OPTION}}} : plus de {{{ATTRIBUTE_COUNT}}} options ont été désélectionnées.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} à {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Au moins {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Saisissez un nombre de pages compris entre {{{MINIMUM}}} et {{{MAXIMUM}}}, couverture incluse ";
var rangePartialRangedHelperTextForBooklets = "Au moins {{{MINIMUM}}} pages, couverture incluse ";
var rangedGeneralInputError = "L’entrée n’est pas valide";
var rangedBetweenRangesError = "Les nombres les plus proches sont {{{LOWER}}} {{{UNIT}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Le nombre ne peut pas dépasser 8 décimales";
var rangedMinInputValueError = "Le nombre minimum est de {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Le nombre maximum est de {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "L'entrée doit être un nombre";
var requiredAttributeFieldError = "Saisir une valeur comprise entre {{{LOWER}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Les nombres de pages les plus proches sont {{{LOWER}}} et {{{HIGHER}}} ";
var rangedMinInputValueErrorForBooklets = "Le nombre minimum de pages est de {{{MINIMUM}}} ";
var rangedMaxInputValueErrorForBooklets = "Le nombre maximum de pages est de {{{MAXIMUM}}} ";
var requiredAttributeFieldErrorForBooklets = "Saisissez un nombre de pages compris entre {{{LOWER}}} et {{{HIGHER}}}, couverture incluse ";
var requiredInformationToast = "Veuillez fournir toutes les informations requises.";
var frCa = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, frCa as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=fr-ca.json.mjs.map
